import axios from "axios";
import { ADD_LEAD_ITEM, DELETE_LEAD_ITEM, GET_ALL_LEAD, GET_ALL_LEAD_CATEGORY, GET_ALL_LEAD_FAILED, GET_ALL_LEAD_SUCCESS, UPDATE_LEAD_ITEM } from "../../constants/leadConstants";
import ToastManager from "../../../modules/default/popup/alert/apiNotification";

export const GetAllLeads = (data) => async(dispatch) => {
    dispatch({ type: GET_ALL_LEAD });
    try {
        const res = await axios.get(`/prospector`, {params: data});
        
        dispatch({ 
            type: GET_ALL_LEAD_SUCCESS, 
            payload: {
                data: res.data.data,
                pagination: res.data.pagination,
                page: data.page 
            }
        });
    } catch(error) {
        dispatch({ type: GET_ALL_LEAD_FAILED, payload: error.message });
    }
};
export const AddNewLead = (data) => async(dispatch) => {
    const toastId = ToastManager.showLoading('Processing...');
    try {
        const response = await axios.post(`/prospector`, data);
        if(response.status >= 200 && response.status < 300){
            ToastManager.showSuccess(toastId, response.data.message || 'Lead added successfully!');
            dispatch({ 
                type: ADD_LEAD_ITEM, 
                payload: {
                    data: response.data.data,
                }
            });
            return response;
        }
       
    } catch(error) {
        let errorMsg = Object.values(error.response.data).join(', ')
        ToastManager.showError(toastId, errorMsg || 'Failed to add lead.');
    }
};
// Update user notification data
export const UpdateLeadItem = (formData) => async (dispatch) => {
    const notificationId = ToastManager.showLoading('Updating...');
    try {
        const response = await axios.put('/prospector', formData);

        if (response.status >= 200 && response.status < 300) {
            ToastManager.showSuccess(notificationId, response.data.message || 'Updated successfully!');
            dispatch({ 
                type: UPDATE_LEAD_ITEM,
				payload: {
					data: response.data,
				},
             });
            return response;
        }
    } catch (err) {
        let errorMsg = Object.values(err.response.data).join(', ')
        ToastManager.showError(notificationId, errorMsg || 'Update failed');
    }
};
export const DeleteLeadItem = (id) => async(dispatch) => {
    const toastId = ToastManager.showLoading('Deleting...');
    try {

        const response = await axios.delete(`/prospector`, {
            data:{ id: id}
        });
        if(response.status >= 200 && response.status < 300){
            ToastManager.showSuccess(toastId, response.data.message || 'Lead deleted successfully!');
            dispatch({ 
                type: DELETE_LEAD_ITEM, 
                payload: {
                    id: id
                }
            });
            return response;
        }

    } catch(err) {
        let errorMsg = Object.values(err.response.data).join(', ')
        ToastManager.showError(toastId, errorMsg || 'Failed to delete lead.');
    }
};

export const GetAllLeadCategory = (data) => async(dispatch) => {
    dispatch({ type: GET_ALL_LEAD });
    try {
        const res = await axios.get(`/essential/group?type=prospectors`, {params: data});
        
        dispatch({ 
            type: GET_ALL_LEAD_CATEGORY, 
            payload: {
                data: res.data.data,
                pagination: res.data.pagination,
                page: data.page 
            }
        });
    } catch(error) {
        dispatch({ type: GET_ALL_LEAD_FAILED, payload: error.message });
    }
};
